var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usuario)?_c('div',{staticClass:"info-historico"},[_c('h1',[_vm._v(_vm._s(_vm.usuario.nome))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }